<div class="unavailable">
    <h1>Scenario unavailable</h1>
    <p *ngIf="reason && reason.detail" class="text-danger">{{reason.detail}}</p>
</div>